import { render } from "./RowColComponent.vue?vue&type=template&id=16de44a4"
import script from "./RowColComponent.vue?vue&type=script&lang=js"
export * from "./RowColComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__